<template>
  <modal
    class="addPM"
    name="addPM"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @opened="opened"
    @closed="closed"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/bank-building (2).svg" width="50px" />
          </span>
          {{ $t("text.priceManager.addPM") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="">
              <div style="display: flex; justify-content: flex-start">
                <label class="required">
                  {{ $t("text.priceManager.selectUser") }}
                </label>
              </div>

              <div class="" ref="target_input_div">
                <multiselect
                  v-model="user"
                  :options="companyUsers"
                  :custom-label="nameWithMail"
                  :placeholder="$t('text.priceManager.selectUser')"
                  track-by="id"
                  :loading="usersLoading"
                ></multiselect>

                <!-- <select v-model="user">
                  <option selected disabled value="selectUser">
                    {{ $t("text.priceManager.selectUser") }}
                  </option>
                  <option v-if="usersLoading" value="">
                    {{ $t("text.priceManager.loading") }}
                  </option>
                  <option
                    v-else
                    :value="
                      $route.query.entityType == 'Company'
                        ? users.userId
                        : users.id
                    "
                    v-for="users in companyUsers"
                    :key="users.userId"
                  >
                    {{ users.firstName }} {{ users.lastName }} -
                    {{
                      $route.query.entityType == "Company" ||
                      $route.query.entityType == "Group"
                        ? users.email
                        : users.userName
                    }}
                  </option>
                </select> -->
              </div>
            </div>

            <div class="mt-4">
              <div style="display: flex; justify-content: flex-start">
                <label class="required">
                  {{ $t("text.priceManager.position") }}
                </label>
              </div>
              <div class="input__block" ref="target_input_div">
                <input
                  style="padding: 20px; width: 100%"
                  type="text"
                  :placeholder="$t('text.priceManager.position')"
                  v-model="position"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.cAggregated.type") }}
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <select v-model="selectType">
                      <!-- <option selected disabled value="selectType">
                        {{ $t("text.createTrucksModal.selectType") }}
                      </option> -->
                      <!-- <option value="PriceChange">
                        {{ $t("text.priceManager.priceChange") }}
                      </option>
                      <option value="PumpCaliberation">
                        {{ $t("text.pumpsCalibration.title") }}
                      </option> -->
                      <option disabled v-if="typesLoading" value="">
                        {{ $t("text.priceManager.loading") }}
                      </option>
                      <option
                        v-else
                        selected
                        :value="type.id"
                        v-for="type in companyTypes"
                        :key="type.id"
                      >
                        {{ type.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div style="display: flex; justify-content: flex-start">
                    <label class="required">
                      {{ $t("text.priceManager.level") }}
                      <span v-if="selectType == 'selectType'"
                        >({{ $t("text.priceManager.selTypeToEnable") }})</span
                      >
                    </label>
                  </div>
                  <div class="input__block" ref="target_input_div">
                    <select
                      :disabled="selectType == 'selectType'"
                      v-model="selectLevel"
                    >
                      <!-- <option disabled value="selectLevel">
                        {{ $t("text.priceManager.selectLevel") }}
                      </option> -->
                      <option disabled v-if="levelsLoading" value="">
                        {{ $t("text.priceManager.loading") }}
                      </option>
                      <option
                        v-else
                        :value="level"
                        v-for="level in companyLevels"
                        :key="level"
                      >
                        {{ level }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center mt-5">
              <button
                class="add_quick_fuel_btn"
                @click="addNewPM($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                <span>{{ $t("text.cDrystock.add") }} </span>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";

import Multiselect from "vue-multiselect";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "addPM",
  props: ["companyId", "entityId"],
  components: {
    Multiselect,
  },
  data() {
    return {
      // user: "selectUser",
      user: null,
      companyUsers: [],
      companyLevels: null,
      companyTypes: [],
      // selectType: "selectType",
      selectType: "2b08de86-ab7c-4f89-b918-cf67138a2351",
      selectLevel: "selectLevel",
      position: null,
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      usersLoading: false,
      levelsLoading: false,
      typesLoading: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  watch: {
    // selectType() {
    //   if (this.selectType !== "selectType") {
    //     this.getCompanyLevels();
    //   }
    // },
    companyLevels() {
      if (this.companyLevels) {
        this.selectLevel = this.companyLevels[0];
      }
    },
  },
  methods: {
    nameWithMail({ firstName, lastName, email, userName }) {
      return `${firstName} ${lastName} - ${
        this.$route.query.entityType == "Company" ||
        this.$route.query.entityType == "Group"
          ? email
          : userName
      }`;
    },

    opened() {
      this.getCompanyUsers();
      this.getCompanyLevels();
      this.getCompanyTypes();
    },

    closed() {
      // this.user = "selectUser";
      this.user = null;
      // this.selectType = "selectType";
      this.selectType = "2b08de86-ab7c-4f89-b918-cf67138a2351";
      this.selectLevel = "selectLevel";
      this.position = null;
      this.isButtonDisabled = false;
      this.usersLoading = false;
      this.levelsLoading = false;
      this.typesLoading = false;
    },

    getCompanyUsers() {
      this.usersLoading = true;

      let url;

      if (this.$route.query.entityType == "Company") {
        url = `${configObject.apiBaseUrl}/Company/Usersv2/${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.companyId
        }`;
      } else if (
        this.$route.query.entityType == "Branch" ||
        (this.$route.query.companyId && this.$route.query.branchId)
      ) {
        url = `${configObject.apiBaseUrl}/Branch/Users/${
          this.$route.query.branchId
            ? this.$route.query.branchId
            : this.entityId
        }`;
      } else {
        url = `${configObject.apiBaseUrl}/GroupManagement/Users/${
          this.$route.query.groupId ? this.$route.query.groupId : this.entityId
        }`;
      }

      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.usersLoading = false;
          this.companyUsers = response.data;
        })
        .catch((error) => {});
    },

    getCompanyLevels() {
      this.levelsLoading = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Approval/Type/AvailableLevels?typeId=${
            this.selectType
          }&entityId=${this.entityId}&entityType=${
            this.$route.query.entityType
              ? this.$route.query.entityType
              : "Branch"
          }&actionType=ADD`,
          configObject.authConfig()
        )
        .then((response) => {
          this.levelsLoading = false;
          this.companyLevels = response.data;
        })
        .catch((error) => {});
    },

    getCompanyTypes() {
      this.typesLoading = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Approval/Type/All?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.typesLoading = false;
          this.companyTypes = response.data;
        })
        .catch((error) => {});
    },

    addNewPM($event) {
      $event.preventDefault();

      // if (this.user === "selectUser" || !this.user) {
      if (this.user == null) {
        this.$toast.open({
          message: this.$t("text.priceManager.selectUser"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      if (this.position == null) {
        this.$toast.open({
          message: this.$t("text.priceManager.missingPosition"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      if (this.selectType === "selectType" || !this.selectType) {
        this.$toast.open({
          message: this.$t("text.errors.enterAcctType"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      if (this.selectLevel === "selectLevel" || !this.selectLevel) {
        this.$toast.open({
          message: this.$t("text.priceManager.selectLevel"),
          type: "error",
          duration: 5000,
        });
        this.formIsValid = false;
        return;
      }

      let data = {
        entityId: this.entityId,
        entityType: this.$route.query.entityType
          ? this.$route.query.entityType
          : "Branch",
        userId:
          this.$route.query.entityType == "Company"
            ? this.user.userId
            : this.user.id,
        typeId: this.selectType,
        positionName: this.position,
        position: +this.selectLevel,
      };

      $(".loader").show();
      // console.log(data);
      this.isButtonDisabled = true;

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Approval/Add`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.closeModal();
          this.closed();

          this.$toast.open({
            message: this.$t("text.priceManager.addedPM"),
            type: "success",
            duration: 5000,
          });

          this.$eventHub.$emit("getPM");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },

    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    closeModal() {
      this.$modal.hide("addPM");
    },
  },
};
</script>
